import React, { useState, useEffect } from 'react';
import { Menu, X } from 'lucide-react';
import ThemeToggle from './ThemeToggle';
import Logo from '../ProjectNexus_LogoJust_Trans.svg';

const Header = () => {
    const [isScrolled, setIsScrolled] = useState(false);
    const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

    useEffect(() => {
        const handleScroll = () => {
            setIsScrolled(window.scrollY > 20);
        };
        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    const navLinks = [
        { name: '相談できること', href: '#challenges' },
        { name: '専門性・支援領域', href: '#services' },
        { name: '選ばれる理由', href: '#why-us' },
        { name: '実績・事例', href: '#case-studies' },
        { name: 'チーム', href: '#team' },
        { name: '会社概要', href: '#company' },
        { name: 'お問い合わせ', href: '#contact' },
    ];

    return (
        <header
            className={`fixed w-full z-50 transition-all duration-300 ${isScrolled
                    ? 'bg-white/90 dark:bg-gray-900/90 backdrop-blur-sm shadow-md py-2'
                    : 'bg-transparent py-4'
                }`}
        >
            <div className="container mx-auto px-4 md:px-6 flex justify-between items-center">
                <a href="/" className="flex items-end gap-2">
                    <img
                        src={Logo}
                        alt="Project NEXUS Logo"
                        className="h-8 w-auto transition-all duration-300 brightness-0 dark:invert"
                    />
                    <span className="text-xs font-light ml-2 mb-1 transition-colors duration-300 text-gray-500 dark:text-gray-400">
                        by eriver.jp
                    </span>
                </a>

                {/* Desktop Navigation */}
                <nav className="hidden lg:flex items-center gap-4 xl:gap-6 whitespace-nowrap">
                    {navLinks.map((link) => (
                        <a
                            key={link.name}
                            href={link.href}
                            className="text-sm xl:text-base font-medium transition-colors text-gray-600 dark:text-gray-300 hover:text-black dark:hover:text-white"
                        >
                            {link.name}
                        </a>
                    ))}
                    <ThemeToggle />
                </nav>

                {/* Mobile Menu Button */}
                <div className="lg:hidden flex items-center gap-4">
                    <ThemeToggle />
                    <button
                        onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
                        aria-label={isMobileMenuOpen ? 'メニューを閉じる' : 'メニューを開く'}
                        aria-expanded={isMobileMenuOpen}
                        className="focus:outline-none text-gray-600 dark:text-gray-300"
                    >
                        {isMobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
                    </button>
                </div>
            </div>

            {/* Mobile Navigation */}
            {isMobileMenuOpen && (
                <div className="lg:hidden bg-white dark:bg-gray-900 shadow-lg absolute w-full left-0 top-full py-4 px-4 flex flex-col gap-4 max-h-[calc(100vh-4rem)] overflow-y-auto">
                    {navLinks.map((link) => (
                        <a
                            key={link.name}
                            href={link.href}
                            className="text-gray-600 dark:text-gray-300 hover:text-black dark:hover:text-white font-medium py-2 border-b border-gray-100 dark:border-gray-800 last:border-0"
                            onClick={() => setIsMobileMenuOpen(false)}
                        >
                            {link.name}
                        </a>
                    ))}
                </div>
            )}
        </header>
    );
};

export default Header;
